import { Chip, Stack, Typography, useTheme } from "@mui/material";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { dashboard_view_customer } from "../../../helpers/rights/rights";
import useUserData from "../../../hooks/user/useUserData";
import { DASHBOARD } from "../../../locales/pages/namespaces";
import PermissionHOC from "../../../modules/permission/components/permissionHOC/permissionHOC";
import CardChip from "./cardChip";
import CardFieldInfo from "./cardFIeldInfo";

const DashboardListItemButton = ({ data, selected, onClick, sx }) => {
	const theme = useTheme()
	const { t } = useTranslation(DASHBOARD)
	const { dateFormat } = useUserData()
	return (
		<ListItemButton
			sx={{
				...sx,
				borderLeft: `4px solid ${theme.palette.primary[200]}`,
				'&:hover': {
					background: theme.palette.primary[200],
					borderLeft: '4px solid #5e8af7',
				},
				'&.Mui-selected': {
					borderLeft: '4px solid #5e8af7',
				},
				padding: 1
			}}
			selected={selected}
			onClick={onClick}
			divider
		>
			<ListItemText>
				<Divider sx={{ borderColor: theme.palette.primary[200] }}/>
				<Tooltip title={data?.Description}>
					<Typography
						variant={'body2'}
						component={'div'}
						color={'primary'}
						sx={{ color: 'secondary.dark', fontWeight: 'bold' }}
					>
						{data?.Code} - {data?.Description.length > 100 ? data?.Description.substring(0, 100) + '...' : data?.Description}
					</Typography>
				</Tooltip>
				<Divider sx={{ borderColor: theme.palette.primary[200] }}/>
				<CardFieldInfo label={t('Reference Code')}>
					{data?.ErpCode2 ? data?.ErpCode2 : '-'}
				</CardFieldInfo>
				<PermissionHOC requiredPermissions={[dashboard_view_customer]}>
					<CardFieldInfo label={t('Customer')}>
						{data?.CustName}
					</CardFieldInfo>
				</PermissionHOC>
				<CardFieldInfo label={t('Site')}>
					{data?.Site ? data?.Site : '-'}
				</CardFieldInfo>
				<CardFieldInfo label={t('Service')}>
					{data?.ItemDescription ? data?.ItemDescription : '-'}
				</CardFieldInfo>
				<CardFieldInfo
					label={t('Targeted Start')}
				>
					{data.TargetedStartDt ? dayjs(data.TargetedStartDt).format(dateFormat) : '-'}
				</CardFieldInfo>
				<CardFieldInfo
					label={t('Targeted Expiry')}
					sx={{ color: dayjs(data.TargetedEndDt)?.isValid() && dayjs(data.TargetedEndDt)?.isBefore(dayjs(), 'date') ? 'error.main' : 'inherit' }}
				>
					{data.TargetedEndDt ? dayjs(data.TargetedEndDt).format(dateFormat) : '-'}
				</CardFieldInfo>
				<Stack direction="row" spacing={1} sx={{
					flexWrap: 'wrap',
					justifyContent: 'end',
					rowGap: 0.5
				}}>
					{data.Type && (
						<CardChip
							label={data.Type}
							color={data?.TypeColor}
							borderColor={data?.TypeColor}
						/>
					)}
					{data.Priority && (
						<CardChip
							label={data.Priority}
							color={data?.PriotiryColor}
							borderColor={data?.PriotiryColor}
						/>
					)}
					{data.Status && (
						<CardChip
							label={data.Status}
							color={data?.StatusColor}
							borderColor={data?.StatusColor}
						/>
					)}
				</Stack>
			</ListItemText>
		</ListItemButton>
	);
};

export default DashboardListItemButton